import queryString from "query-string";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Services from "../../../API/common/sharedServices";
import { useGlobalContext } from "../../../context/globalContext";
import useServiceType from "../../../hooks/useServiseType";
import Loader from "../../../shared/loaders/simpleLoader";
import { SERVICE_TYPES } from "../../../utils/constants/fieldErrors";
import { setPersistedIdentificationStatus } from "../../../utils/constants/piFormSession";
import { redirectToPiOnboardingIdentification } from "../../piOnboarding/steps/helpers";
import { ONBOARDING_BASE_PATHS, ROUTES } from "../../piOnboarding/steps/constants";

const addMobileWithLanguage = (path, i18n) => {
  const mobile = sessionStorage.getItem("mobile");
  const userId = localStorage.getItem("userId");
  return `${path}${mobile ? "/mobile" : ""}/${i18n.language}${
    userId ? `/${userId}` : ""
  }`;
};

export function generateServicetypePath(
  redirectPath,
  serviceTypeFromAPI,
  i18n
) {
  if (redirectPath === "/agreement") {
    switch (serviceTypeFromAPI.toString()) {
      case "1":
        return addMobileWithLanguage(`/Identomat`, i18n);
      case "2":
        return addMobileWithLanguage(`/creditinfo/agreement`, i18n);
      case "3":
        return addMobileWithLanguage(`/ContactInfoChange/agreement`, i18n);
      case "4":
        return addMobileWithLanguage(`/ibRegistration/agreement`, i18n);
      case "5":
        return addMobileWithLanguage(`/IBservicechange/agreement`, i18n);
      case "6":
        return addMobileWithLanguage(`/KYCform/agreement`, i18n);
      case "7":
        return addMobileWithLanguage(`/Legal/agreement`, i18n);
      case "8":
        return addMobileWithLanguage(`/identification/agreement`, i18n);
      case "10":
        return `/${ONBOARDING_BASE_PATHS.loan}/${ROUTES.identification}`;
    }
  }
}

const Callback = () => {
  const history = useHistory();
  const location = history.location.search;
  const { i18n, t } = useTranslation();
  const { serviceType, setServiceType, serviceTypeFromCallback } =
    useServiceType();

  const {
    setGlobalData,
    globalData,
    setShown,
    setErrorMessage,
    setShowBlockedModal,
  } = useGlobalContext();

  const { session_token } = queryString.parse(location);

  const service = sessionStorage.getItem("servicetype");

  const isPiOnboardingFlow = () =>
    Boolean(sessionStorage.getItem("onboardingToken"));

  function generatePath(redirectPath, serviceTypeFromAPI) {
    if (redirectPath === "/step/3") {
      switch (serviceTypeFromAPI) {
        case SERVICE_TYPES.PIForm:
          return "/step/3";
        case SERVICE_TYPES.creditInfoForm:
          return "/creditinfo/step/3";
        case SERVICE_TYPES.loanApplication:
          return `/${ONBOARDING_BASE_PATHS.loan}/${ROUTES.privateInformation}`;
        case SERVICE_TYPES.ContactInfoChangeForm:
          return "/ContactInfoChange/step/3";
        case SERVICE_TYPES.ibRegistration:
          return "/ibRegistration/step/3";
        case SERVICE_TYPES.IBservicechange:
          return "/IBservicechange/step/3";
        case SERVICE_TYPES.KYCform:
          return "/KYCform/step/3";
        case SERVICE_TYPES.Legal:
          return "/Legal/step/4";
        case SERVICE_TYPES.identification:
          return "/identification/step/3";
      }
    } else if (redirectPath === "/agreement") {
      switch (serviceTypeFromAPI || serviceType) {
        case SERVICE_TYPES.PIForm:
          return addMobileWithLanguage(`/Identomat`, i18n);
        case SERVICE_TYPES.creditInfoForm:
          return addMobileWithLanguage(`/creditinfo/agreement`, i18n);
        case SERVICE_TYPES.loanApplication:
          return `/${ONBOARDING_BASE_PATHS.loan}/${ROUTES.identification}`;
        case SERVICE_TYPES.ContactInfoChangeForm:
          return addMobileWithLanguage(`/ContactInfoChange/agreement`, i18n);
        case SERVICE_TYPES.ibRegistration:
          return addMobileWithLanguage(`/ibRegistration/agreement`, i18n);
        case SERVICE_TYPES.IBservicechange:
          return addMobileWithLanguage(`/IBservicechange/agreement`, i18n);
        case SERVICE_TYPES.KYCform:
          return addMobileWithLanguage(`/KYCform/agreement`, i18n);
        case SERVICE_TYPES.Legal:
          return addMobileWithLanguage(`/Legal/agreement`, i18n);
        case SERVICE_TYPES.identification:
          return addMobileWithLanguage(`/identification/agreement`, i18n);
      }
    }
  }

  useEffect(() => {
    let redirectTimeoutId;

    Services.sendSessionToken(session_token)
      .then((res) => {
        setGlobalData({
          ...globalData,
          status: res.data.result,
          localToken: res.data.localToken,
          person: {
            ...res.data.additionalInfo,
            ...res.data.person,
          },
          additionalInfo: res.data.additionalInfo,
        });
        setPersistedIdentificationStatus(res.data.result);
        if (res.data.result === "Rejected") {
          const resolvedServiceType =
            res.data.serviceType || service || serviceType;

          setServiceType(resolvedServiceType);
          serviceTypeFromCallback.current = res.data.serviceType;
          sessionStorage.removeItem("localToken");
          setPersistedIdentificationStatus("");

          if (res.data.blocked === true) {
            setErrorMessage(t("blockedError"));
            setShowBlockedModal(true);
          } else if (res.data.alreadyHasAccounts === true) {
            setErrorMessage(t("hasAlreadyAccountsError"));
          } else {
            setErrorMessage(t("errorText"));
          }
          setShown(true);

          if (isPiOnboardingFlow()) {
            redirectTimeoutId = setTimeout(() => {
              redirectToPiOnboardingIdentification();
            }, 5000);
            return;
          }

          history.push(generatePath("/agreement", resolvedServiceType));
        } else if (res.data.result === "Approved") {
          setServiceType(res.data.serviceType);
          serviceTypeFromCallback.current = res.data.serviceType;
          sessionStorage.setItem("localToken", res.data.localToken);
          localStorage.setItem("sessionToken", session_token);
          history.push(generatePath("/step/3", res.data.serviceType));
        }
      })
      .catch((error) => {
        sessionStorage.removeItem("localToken");
        setPersistedIdentificationStatus("");

        setErrorMessage(t("errorText"));
        setShown(true);

        if (isPiOnboardingFlow()) {
          redirectTimeoutId = setTimeout(() => {
            redirectToPiOnboardingIdentification();
          }, 5000);
          return;
        }

        history.push(
          generateServicetypePath("/agreement", service || serviceType, i18n)
        );
      });

    return () => {
      if (redirectTimeoutId) {
        clearTimeout(redirectTimeoutId);
      }
    };
  }, []);

  return (
    <div>
      <Loader />
    </div>
  );
};

export default Callback;
